import { DishModal } from "./DishModal";

export default DishModal;
